import { Category } from '@smg-real-estate/hg-rets-schema';
import {
  getCategoriesForSearchModel,
  SearchModel,
  TravelTimeFilter,
} from '@smg-real-estate/hg-search-libs';

import { getH3ReachableCells } from '@/helpers/SessionStorage/h3ReachableCellsStorage';
import { SearchCriteria } from '@/store/types/search-criteria';

export interface SavedSearch {
  identifier: string;
}

export function polygonSearchCriteria(searchCriteria: SearchCriteria): SearchCriteria {
  return {
    ...searchCriteria,
    polygon: undefined,
    locations: undefined,
    radius: undefined,
    geoLocation: {
      inMultiPolygon: {
        multiPolygon: structuredClone(searchCriteria.polygon),
      },
    },
  };
}

export function cleanupSearchModel(searchModel: SearchModel): SearchCriteria {
  const searchCriteria = {
    ...structuredClone(searchModel),
    page: undefined,
    pageSize: undefined,
    sortDirection: undefined,
    sortType: undefined,
    objectTypes: undefined,
  } as SearchCriteria;

  if (searchCriteria.polygon) {
    return polygonSearchCriteria(searchCriteria);
  }

  return searchCriteria;
}

export function createPayloadSearchCriteria(searchModel: SearchModel): SearchCriteria {
  const { categories, excludeCategories } = getCategoriesForSearchModel(searchModel) as {
    categories: Category[];
    excludeCategories: Category[];
  };

  const search_criteria = cleanupSearchModel(searchModel);

  const reachableH3Cells = getH3ReachableCells();

  if (searchModel.travelTime && reachableH3Cells && reachableH3Cells.length > 0) {
    search_criteria.travelTime = {
      ...search_criteria.travelTime,
      reachableH3Cells,
    } as TravelTimeFilter;
  } else {
    search_criteria.travelTime = undefined;
  }

  return {
    ...search_criteria,
    categories,
    excludeCategories,
  };
}
